import { render, staticRenderFns } from "./ReviewsCard.vue?vue&type=template&id=45c38efe&"
import script from "./ReviewsCard.vue?vue&type=script&lang=js&"
export * from "./ReviewsCard.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCard.vue?vue&type=style&index=0&id=45c38efe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports